import React from "react";
import styled from "styled-components";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoWithText from "../../assets/logo/LogoWithText.png";

export default function Sidebar({ sidebarOpen, toggleSidebar, navigate, currentPage }) {
  const handleNav = (page) => {
    toggleSidebar(false);
    if (navigate) navigate(page);
  };

  return (
    <Wrapper sidebarOpen={sidebarOpen} className={sidebarOpen ? "open" : ""}>
      <SidebarHeader className="flexSpaceCenter">
        <LogoBtn onClick={() => handleNav("home")} className="pointer">
          <img src={LogoWithText} alt="הלב הצבעוני" height="45" />
        </LogoBtn>
        <CloseBtn onClick={() => toggleSidebar(false)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("home")}
            className={`darkColor${!currentPage || currentPage === "home" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            בית
          </NavBtn>
        </li>
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("journal")}
            className={`darkColor${currentPage === "journal" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            יומן ויזואלי
          </NavBtn>
        </li>
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("cards")}
            className={`darkColor${currentPage === "cards" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            קלפי נפש
          </NavBtn>
        </li>
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("visionboard")}
            className={`darkColor${currentPage === "visionboard" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            לוח חזון
          </NavBtn>
        </li>
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("workshops")}
            className={`darkColor${currentPage === "workshops" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            סדנאות
          </NavBtn>
        </li>
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("about")}
            className={`darkColor${currentPage === "about" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            אודות
          </NavBtn>
        </li>
        <li className="semiBold font15 pointer">
          <NavBtn
            onClick={() => handleNav("contact")}
            className={`darkColor${currentPage === "contact" ? " activeTab" : ""}`}
            style={{ padding: "10px 15px" }}
          >
            צרי קשר
          </NavBtn>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  padding: 0 30px;
  z-index: 9999;
  background: var(--page-bg);
  box-shadow: -20px 0 60px -20px rgba(73, 8, 57, 0.25);
  transform: translateX(${(props) => (props.sidebarOpen ? "0" : "105%")});
  transition: transform 0.6s var(--ease-out);
  @media (max-width: 400px) {
    width: 100%;
  }
  /* links cascade in once the panel opens */
  li {
    opacity: 0;
    transform: translateX(30px);
    transition: opacity 0.4s var(--ease-out), transform 0.5s var(--ease-spring);
  }
  &.open li { opacity: 1; transform: none; }
  ${[1, 2, 3, 4, 5, 6, 7].map((i) => `&.open li:nth-child(${i}) { transition-delay: ${0.1 + i * 0.05}s; }`).join("\n")}
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const LogoBtn = styled.button`
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
  transition: transform 0.5s var(--ease-spring);
  &:hover { transform: rotate(90deg); }
`;
const NavBtn = styled.span`
  display: inline-block;
  cursor: pointer;
  font-family: var(--font-display);
  font-size: 1.35rem;
  font-weight: 500;
  border-radius: 999px;
  transition: color 0.3s var(--ease-out), background-color 0.3s var(--ease-out), transform 0.4s var(--ease-spring);
  &.activeTab {
    color: var(--rose-600) !important;
    background: rgba(255, 255, 255, 0.65);
    box-shadow: var(--shadow-soft);
  }
  &:hover {
    color: var(--rose-600) !important;
    transform: scale(1.05);
  }
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
